export default "__VITE_ASSET__Q8u5vmBO__"